import Store from '../../store.js'
export default function userHasPrivs(
  requiredPrivs = [],
  config = { operator: 'or' },
  privilege = null
) {
  // old style privilege check
  if (privilege == null) {
    const Auth = Store.getState().auth
    privilege = Auth.privilege || []
  }

  if (!Array.isArray(privilege)) {
    return false
  }
  if (!Array.isArray(requiredPrivs)) {
    requiredPrivs = [requiredPrivs]
  }
  if (requiredPrivs.length === 0) {
    return true
  }

  switch (config.operator.toLowerCase()) {
    case 'or':
      // see if there are any in common between the array of privs the user has
      // and the array of privs we are looking for.
      return requiredPrivs.some(ownedPriv => {
        return privilege.some(
          requiredPrivName => requiredPrivName.name === ownedPriv
        )
      })
    case 'and':
      // see if all elements are common between the array of privs the user has
      // and the array of privs we are looking for.
      return requiredPrivs.every(ownedPriv => {
        return privilege.some(
          requiredPrivName => requiredPrivName.name === ownedPriv
        )
      })
    default:
      throw new Error("Invalid config.operator supplied to userHasPrivs(). Valid operators are 'and' and 'or'.")
  }
}
